/**
 * ROYAL TALLOW - PDP AS LANDING PAGE
 * Dynamic Content & Conversion Optimization Features
 */

(function() {
  'use strict';

  // ============================================
  // DYNAMIC HEADLINE BASED ON AD SOURCE
  // ============================================
  
  function initDynamicHeadline() {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const adSource = urlParams.get('source') || urlParams.get('utm_source');
    
    // Headline mapping based on ad traffic source
    const headlines = {
      'ekaterina': 'Simple. Clean. Radiant.',
      'ekaterina-min': 'Just 3 Ingredients. Real Results.',
      'alison': 'The Luxury Your Skin Deserves',
      'alison-lux': 'Ancient Wisdom, Ageless Skin',
      'minimalist': 'Simple. Clean. Radiant.',
      'luxury': 'The Luxury Your Skin Deserves',
      'ancestral': 'Ancient Wisdom Meets Modern Luxury',
      'transformation': 'Transform Your Skin, Naturally',
      'default': 'The Nourishment Your Skin\'s Been Craving'
    };
    
    // Subheadline mapping
    const subheadlines = {
      'ekaterina': 'Join <strong>1,850+ customers</strong> who discovered why less is more. Two ingredients. One luxurious ritual.',
      'alison': 'Join <strong>1,850+ customers</strong> who chose ancestral skincare over complicated routines.',
      'minimalist': 'Join <strong>1,850+ customers</strong> who discovered why ancestral skincare works better than complicated routines.',
      'luxury': 'Join <strong>1,850+ customers</strong> who experience spa-quality skincare at home.',
      'default': 'Join <strong>1,850+ customers</strong> who discovered why ancestral skincare works better than complicated routines. Two pristine ingredients. One luxurious ritual.'
    };
    
    // Find headline elements
    const headlineElement = document.querySelector('.rt-headline .rte, .rt-headline h1, .rt-headline p');
    const subheadlineElement = document.querySelector('.rt-subheadline .rte, .rt-subheadline p');
    
    // Update headline if ad source is detected
    if (adSource && headlines[adSource]) {
      if (headlineElement) {
        headlineElement.textContent = headlines[adSource];
        console.log('Royal Tallow: Dynamic headline set for source:', adSource);
      }
      
      if (subheadlineElement && subheadlines[adSource]) {
        subheadlineElement.innerHTML = subheadlines[adSource];
      }
    }
  }

  // ============================================
  // STICKY ADD TO CART BAR (Mobile)
  // ============================================
  
  function initStickyATC() {
    // Only run on mobile
    if (window.innerWidth > 749) return;
    
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;
    
    const addToCartButton = productForm.querySelector('.product-form__submit');
    if (!addToCartButton) return;
    
    // Create sticky bar
    const stickyBar = document.createElement('div');
    stickyBar.className = 'sticky-atc-bar';
    stickyBar.style.cssText = `
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: #ffffff;
      padding: 1rem;
      box-shadow: 0 -4px 16px rgba(17, 18, 20, 0.1);
      z-index: 999;
      transform: translateY(100%);
      transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      gap: 1rem;
      align-items: center;
    `;
    
    // Clone product info
    const productPrice = document.querySelector('.price');
    const productTitle = document.querySelector('.product__title');
    
    const infoDiv = document.createElement('div');
    infoDiv.style.cssText = 'flex: 1; min-width: 0;';
    
    if (productTitle) {
      const titleClone = document.createElement('div');
      titleClone.textContent = productTitle.textContent;
      titleClone.style.cssText = 'font-size: 0.875rem; font-weight: 600; color: #111214; margin-bottom: 0.25rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
      infoDiv.appendChild(titleClone);
    }
    
    if (productPrice) {
      const priceClone = productPrice.cloneNode(true);
      priceClone.style.cssText = 'font-size: 1.25rem; font-weight: 700; color: #111214; margin: 0;';
      infoDiv.appendChild(priceClone);
    }
    
    // Clone ATC button
    const stickyButton = addToCartButton.cloneNode(true);
    stickyButton.style.cssText = `
      flex-shrink: 0;
      min-width: 140px;
      margin: 0 !important;
      padding: 0.875rem 1.5rem !important;
      font-size: 0.875rem !important;
      height: auto !important;
      min-height: auto !important;
    `;
    
    // Handle sticky button click
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      addToCartButton.click();
    });
    
    stickyBar.appendChild(infoDiv);
    stickyBar.appendChild(stickyButton);
    document.body.appendChild(stickyBar);
    
    // Show/hide sticky bar based on scroll position
    let lastScrollTop = 0;
    let isVisible = false;
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && window.scrollY > lastScrollTop) {
          // Scrolling down and ATC is out of view
          if (!isVisible) {
            stickyBar.style.transform = 'translateY(0)';
            isVisible = true;
          }
        } else {
          // ATC is in view
          if (isVisible) {
            stickyBar.style.transform = 'translateY(100%)';
            isVisible = false;
          }
        }
        lastScrollTop = window.scrollY;
      },
      {
        threshold: 0,
        rootMargin: '0px 0px -100px 0px'
      }
    );
    
    observer.observe(addToCartButton);
    
    console.log('Royal Tallow: Sticky ATC bar initialized');
  }

  // ============================================
  // SCROLL DEPTH TRACKING
  // ============================================
  
  function initScrollTracking() {
    const scrollMarkers = [25, 50, 75, 100];
    const tracked = new Set();
    
    function trackScroll() {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (window.scrollY / scrollHeight) * 100;
      
      scrollMarkers.forEach(marker => {
        if (scrolled >= marker && !tracked.has(marker)) {
          tracked.add(marker);
          
          // Track event (works with Google Analytics, Meta Pixel, etc.)
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'scroll_depth',
              'scroll_depth': marker
            });
          }
          
          console.log('Royal Tallow: Scroll depth reached:', marker + '%');
        }
      });
    }
    
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          trackScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // ============================================
  // SMOOTH SCROLL TO ANCHOR LINKS
  // ============================================
  
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          const headerOffset = 100;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // ============================================
  // VARIANT CHANGE TRACKING
  // ============================================
  
  function initVariantTracking() {
    const variantSelectors = document.querySelectorAll('.product-form__input input[type="radio"], .product-form__input select');
    
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        const variantValue = e.target.value;
        const variantName = e.target.name;
        
        // Track event
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'select_variant',
            'variant_name': variantName,
            'variant_value': variantValue
          });
        }
        
        console.log('Royal Tallow: Variant selected:', variantName, variantValue);
      });
    });
  }

  // ============================================
  // REVIEW/FAQ INTERACTION TRACKING
  // ============================================
  
  function initInteractionTracking() {
    // Track FAQ accordion opens
    document.querySelectorAll('.accordion__title, .collapsible-row__heading, summary').forEach(item => {
      item.addEventListener('click', (e) => {
        const question = e.target.textContent.trim();
        
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'faq_open',
            'faq_question': question
          });
        }
        
        console.log('Royal Tallow: FAQ opened:', question);
      });
    });
    
    // Track review section clicks
    const reviewLinks = document.querySelectorAll('a[href*="#reviews"], a[href*="review"]');
    reviewLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'review_click'
          });
        }
      });
    });
  }

  // ============================================
  // PRICE UPDATE ON VARIANT CHANGE
  // ============================================
  
  function initDynamicPricing() {
    const priceElement = document.querySelector('.price');
    if (!priceElement) return;
    
    // Update sticky bar price when main price changes
    const priceObserver = new MutationObserver(() => {
      const stickyPrice = document.querySelector('.sticky-atc-bar .price');
      if (stickyPrice && priceElement) {
        stickyPrice.innerHTML = priceElement.innerHTML;
      }
    });
    
    priceObserver.observe(priceElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // ============================================
  // INITIALIZE ALL FEATURES
  // ============================================
  
  function init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    try {
      initDynamicHeadline();
      initStickyATC();
      initScrollTracking();
      initSmoothScroll();
      initVariantTracking();
      initInteractionTracking();
      initDynamicPricing();
      
      console.log('Royal Tallow: PDP-as-LP features initialized successfully');
    } catch (error) {
      console.error('Royal Tallow: Error initializing PDP-as-LP features:', error);
    }
  }
  
  // Run initialization
  init();
  
})();

